import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { BaseService } from '../../shared/services/base.service';
import { environment } from '../../../../environments/environment';

export interface RescheduleAppointmentRequest {
  date: string;
  startTime?: string;
  endTime?: string;
  employeeUid?: string;
}

@Injectable()
export class AppointmentService extends BaseService<any, any> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/appointments');
  }

  reschedule(uid: string, payload: RescheduleAppointmentRequest): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}${this.path}/${uid}/reschedule`, payload);
  }
}
